module.exports = __webpack_public_path__ + "img/bee__5.da08c672.svg";